/**
 * Asynchronously loads the component for ForbiddenPage
 */
import { lazyRoute } from 'components/LazyRoute'

export default lazyRoute(() => import('./index'))
